import { useStore } from 'Portal/src/stores'

export const useDeviceInfoEnabled = () => {
  const { portalConfigStore } = useStore()

  return portalConfigStore.portalConfig?.enableDeviceManagementInfo ?? false
}
